export default __webpack_public_path__ + "static/12_15-a592279367e74dd247c503640d308f54.png";